// Estados de pedido (envío) de las remisiones. Los valores coinciden con
// Remission::ORDER_STATUS_LABELS del API; "recibido" es el valor anterior a "entregado".
export const ORDER_STATUSES = [
  { value: 'pendiente', label: 'PENDIENTE', badge: 'bg-warning' },
  { value: 'aceptado', label: 'ACEPTADO', badge: 'bg-info' },
  { value: 'facturado', label: 'FACTURADO', badge: 'bg-primary' },
  { value: 'enviado', label: 'ENVIADO', badge: 'bg-success' },
  { value: 'en_camino', label: 'EN CAMINO', badge: 'bg-success' },
  { value: 'en_reparto', label: 'EN REPARTO', badge: 'bg-success' },
  { value: 'entregado', label: 'ENTREGADO', badge: 'bg-dark' },
  { value: 'cancelado', label: 'CANCELADO', badge: 'bg-danger' },
  { value: 'devolucion', label: 'DEVOLUCION', badge: 'bg-danger' },
  { value: 'oficina_inter', label: 'OFICINA DE INTER', badge: 'bg-secondary' },
];

// Etiquetas de pauta (campo informativo, vacío por defecto)
export const PAUTAS = ['12 PREPARADOS 1 ODSEQUIO', 'OTRO', 'OFERTAS CUCUTA'];

export function normalizeOrderStatus(status) {
  if (status === 'recibido') return 'entregado';
  return ORDER_STATUSES.some((s) => s.value === status) ? status : 'pendiente';
}

function findStatus(status) {
  const value = normalizeOrderStatus(status);
  return ORDER_STATUSES.find((s) => s.value === value);
}

export function orderStatusLabel(status) {
  return findStatus(status).label;
}

export function orderStatusClass(status) {
  return findStatus(status).badge;
}
